import styled from "styled-components"
import { rem } from "polished"

export const ForecastContainer = styled.div`
  text-align: left;
  font-size: ${rem(12)};
  margin-left: ${rem(8)};
  margin-top: ${rem(12)};
`
